var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.848 92.9813C132.222 121.613 123.288 146.695 91.5443 141.043C74.8505 138.07 39.7808 124.137 24.1983 103.615C6.62898 89.041 15.1772 64.4016 17.7696 50.2107C23.2376 20.2789 58.934 22.0013 90.6777 27.6534C122.421 33.3055 148.316 63.0494 142.848 92.9813Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.611 42.4426C150.611 57.3632 131.047 64.5467 116.049 64.5467C101.051 64.5467 96.2988 57.3632 96.2988 42.4426C96.2988 27.522 115.246 14.8125 130.244 14.8125C145.242 14.8125 150.611 27.522 150.611 42.4426Z",
    fill: "#43D48A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9779 61.5779C47.2323 60.5788 37.5914 60.379 36.9919 67.5723C36.2426 76.5638 34.744 117.025 36.9919 117.775C39.2398 118.524 33.2454 122.271 51.9779 121.521C66.9639 120.922 93.6889 121.272 105.178 121.521C106.926 121.521 110.573 119.873 111.172 113.279M45.9835 68.3211C48.8164 68.3211 52.1324 68.3287 55.7244 68.3465M111.172 78.8113C111.172 77.3127 111.172 71.3183 105.178 69.8197C103.703 69.451 99.2146 69.1674 93.1893 68.9513M55.7244 68.3465C57.9723 63.0929 63.5171 52.436 67.7132 51.8365C71.9092 51.2371 86.4456 62.9966 93.1893 68.9513M55.7244 68.3465C67.7032 68.4056 82.7517 68.577 93.1893 68.9513",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4395 61.5769C95.6864 60.8276 102.03 61.1273 101.431 68.3206",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6991 96.0454C80.3013 90.051 88.1939 85.5552 92.4399 84.0566C100.183 84.5562 116.118 85.7051 117.916 86.3045C120.164 87.0538 120.913 101.291 117.916 104.288C114.919 107.285 96.1864 105.037 90.9413 104.288C85.6963 103.538 85.6963 103.538 82.6991 96.0455L82.6991 96.0454Z",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7027 98.2924C92.1695 97.9045 89.2482 96.3883 89.8293 93.4263C90.5555 89.7239 94.4895 89.3008 94.9737 89.3008C95.4579 89.3008 100.421 89.7768 100.239 94.2726",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.611 42.4426C150.611 57.3632 131.047 64.5467 116.049 64.5467C101.051 64.5467 96.2988 57.3632 96.2988 42.4426C96.2988 27.522 115.246 14.8125 130.244 14.8125C145.242 14.8125 150.611 27.522 150.611 42.4426Z",
    fill: "#EF533F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.646 39.9564C115.497 42.4124 119.447 47.2017 120.435 46.7105C121.669 46.0965 128.458 36.2724 132.161 33.8164",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.d13d1665ae6b06d57faf8301d806e405.svg";
export { ForwardRef as ReactComponent };